import { Component, Input, OnChanges } from '@angular/core';
import { Step } from '../booking/model/booking.model';

@Component({
  selector: 'markant-platform-booking-step',
  templateUrl: './booking-step.component.html',
  styleUrls: ['./booking-step.component.scss'],
})
export class BookingStepComponent implements OnChanges {
  @Input() bookingStep!: Step;

  stepIndex = 0;

  ngOnChanges(): void {
    switch (this.bookingStep) {
      case 'form':
        this.stepIndex = 0;
        break;
      case 'overview':
        this.stepIndex = 1;
        break;
      case 'confirmation':
        this.stepIndex = 2;
        break;
    }
  }
}
